/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Communication
 * Handles all communication channels for the TheCargo platform — email, SMS, in-app notifications, and VoIP calling.

## Authentication

All protected endpoints require a JWT Bearer token obtained via the Auth service `POST /api/v1/auth/login`.

```
Authorization: Bearer <access_token>
```

## Channels

- **Email** — SendGrid SMTP, template rendering, attachment support
- **SMS** — Telnyx API, queue-based delivery with rate limiting
- **Notifications** — Real-time in-app alerts via WebSocket
- **Power Dialer** — Automated outbound call queue with human/voicemail detection

## Contact

For API access or issues contact **support@thecargo.io**
 * OpenAPI spec version: 1.0.1
 */

export type CampaignTab = (typeof CampaignTab)[keyof typeof CampaignTab]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignTab = {
  all: 'all',
  running: 'running',
  scheduled: 'scheduled',
  finished: 'finished',
  drafts: 'drafts',
  organization: 'organization',
  mine: 'mine',
} as const
